<template>
  <Tooltip placement="bottom-end">
    <template #trigger>
      <StyledButton
        class="min-w-0"
        left-icon="calendar_month"
        variant="secondary"
        :disabled="dietStatus === 3"
        @click="modalOpen = true"
      >
        {{ displayText }}
      </StyledButton>
    </template>
    <span v-if="dietStatus === 3">Zduplikuj ten jadłospis, żeby móc go edytować jako Szkic</span>
    <span v-else>{{ hasDates ? 'Zmień datę' : 'Ustaw daty jadłospisu' }}</span>
  </Tooltip>
  <ChangeDietDatesModal
    v-if="modalOpen"
    :days-count="daysCount"
    :diet-id="dietId"
    :is-shared-with-patient="inApp"
    :start-date="startDate"
    @close="modalOpen = false"
    @success="handleSuccess"
  />
</template>

<script lang="ts" setup>
  import { format } from 'date-fns'
  import { storeToRefs } from 'pinia'
  import { computed, ref } from 'vue'

  import { StyledButton } from '@/components/StyledButton'
  import { Tooltip } from '@/components/ui'
  import { useDietsStore } from '@/store/dietsStore'
  import { resolveMealPlanDaysCount } from '@/utils/dietDays'

  import ChangeDietDatesModal from './components/ChangeDietDatesModal/ChangeDietDatesModal.vue'

  const props = defineProps<{
    dietId: number
    startDate?: Date | null
    endDate?: Date | null
    dietStatus?: number
  }>()
  const emit = defineEmits<{ refresh: [] }>()
  const { diet, inApp } = storeToRefs(useDietsStore())
  const modalOpen = ref(false)
  const daysCount = computed(() =>
    resolveMealPlanDaysCount({
      diet: diet.value,
      dietId: props.dietId,
      endDate: props.endDate,
      startDate: props.startDate,
    }),
  )
  const hasDates = computed(
    () =>
      props.startDate instanceof Date &&
      props.endDate instanceof Date &&
      !Number.isNaN(props.startDate.getTime()) &&
      !Number.isNaN(props.endDate.getTime()),
  )
  const displayText = computed(() =>
    hasDates.value && props.startDate && props.endDate
      ? `${format(props.startDate, 'dd.MM')} - ${format(props.endDate, 'dd.MM')}`
      : 'Ustaw daty',
  )

  function handleSuccess() {
    modalOpen.value = false
    emit('refresh')
  }
</script>
